import { Operator } from '../../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';

const BooleanAttributeValue = ({ selectedOperator, fieldName, showLabel, readOnly = false }) => {

  switch (selectedOperator) {
    case Operator.EQUAL:
    case Operator.NOT_EQUAL:
      return <EqualValue showLabel={showLabel} fieldName={fieldName} readOnly={readOnly} /> ;
    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <>{/*MEANS ATTRIBUTE IS UNDEFINED*/}</>;
    default:
      return <></>;
  }
};

export default BooleanAttributeValue;
